import { useController } from 'react-hook-form';
import CurrencyInputBase, {
  CurrencyInputBaseProps,
} from './currency-input-base/currency-input-base.component';
import { IncField } from '../fields.types';

type CurrencyFieldProps = IncField<CurrencyInputBaseProps> & {
  onInputValueChange?: (value: any) => void;
};

const CurrencyField = ({
  name,
  onInputValueChange,
  inputProps,
  IncFormHelperTextProps,
  ...rest
}: CurrencyFieldProps) => {
  const {
    field: { onChange: rhfOnChange, value: fieldValue, ...fieldRest },
    fieldState: { error },
  } = useController({ name });

  return (
    <CurrencyInputBase
      inputProps={{
        onValueChange: value => {
          rhfOnChange(value ?? '');
          onInputValueChange?.(value);
        },
        ...inputProps,
      }}
      InputLabelProps={{ shrink: fieldValue !== '' }}
      IncFormHelperTextProps={{ error, ...IncFormHelperTextProps }}
      value={fieldValue}
      {...rest}
      {...fieldRest}
    />
  );
};

export default CurrencyField;
